import React, { useContext, useState, useEffect } from 'react';
import { useAuthQuery as useQuery } from '../../../../shared/hooks/useAuthQuery';
import { useMutation } from 'convex/react';
import { api } from '../../../../convex/_generated/api';
import { Button } from '../../../../catalyst-components/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../catalyst-components/table';
import { Textarea } from '../../../../catalyst-components/textarea';
import { Alert, AlertTitle, AlertDescription, AlertActions } from '../../../../catalyst-components/alert';
import { getDateTIme } from '../../../../shared/helpers/get-date-time';
import Markdown from 'react-markdown'
import { BaseContext } from '../../../../shared/base-context';

export const DisclaimersTab: React.FC = () => {
  const [content, setContent] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const disclaimers = useQuery(api.disclaimers.getAllDisclaimers);
  const createDisclaimer = useMutation(api.disclaimers.createDisclaimer);
  const {convexUserId} = useContext(BaseContext);
  
  const handleSave = async () => {
    try {
      await createDisclaimer({ content, user_id: convexUserId });
      setAlertMessage('Disclaimer saved successfully!');
      setSuccess(true);
      setShowAlert(true);
    } catch (error) {
      setAlertMessage('Error saving disclaimer. Please try again.');
      setSuccess(false);
      setShowAlert(true);
    }
  };

  useEffect(() => {
    if (disclaimers) {
      setContent(disclaimers[0].content);
    }
  }, [disclaimers]);

  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-4 mb-8">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold">Create New Version</h2>
          <Button 
            color="light" 
            onClick={() => setShowPreview(!showPreview)}
          >
            {showPreview ? 'Edit' : 'Preview'}
          </Button>
        </div>

        {showPreview ? (
          <div className="prose max-w-none p-4 bg-white rounded-lg border">
            <Markdown components={{
              // ol: ({ children }) => <ol className="list-decimal">{children}</ol>,
              // ul: ({ children }) => <ul className="list-disc">{children}</ul>,
            }}>{content}</Markdown>
            {/* <div dangerouslySetInnerHTML={{
              __html: parseMarkdown(content)
            }} /> */}
          </div>
        ) : (
          <Textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter disclaimer text (supports Markdown)"
            rows={10}
          />
        )}

        <div className="flex justify-end">
          <Button 
            color="dark" 
            onClick={handleSave}
            disabled={!content.trim()}
          >
            Save New Version
          </Button>
        </div>
      </div>

      <h2 className="text-xl font-semibold mb-4">Version History</h2>
      <Table striped>
        <TableHead>
          <TableRow>
            <TableHeader>Version</TableHeader>
            <TableHeader>Created At</TableHeader>
            <TableHeader>Created By</TableHeader>
            <TableHeader>Content Preview</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {disclaimers?.map((disclaimer) => (
            <TableRow key={disclaimer._id}>
              <TableCell>{disclaimer.version}</TableCell>
              <TableCell>{getDateTIme(disclaimer.created_at)}</TableCell>
              <TableCell>{disclaimer.creator_email}</TableCell>
              <TableCell className="max-w-xl truncate">{disclaimer.content}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Alert open={showAlert} onClose={() => setShowAlert(false)} size="lg">
        <AlertTitle>{success ? 'Success' : 'Error'}</AlertTitle>
        <AlertDescription>{alertMessage}</AlertDescription>
        <AlertActions>
          <Button plain onClick={() => setShowAlert(false)}>
            Ok
          </Button>
        </AlertActions>
      </Alert>
    </div>
  );
};
